import React from "react";
import Badge from "@mui/material/Badge";

const BadgeComp = ({ sx = {}, ...props }) => <Badge sx={sx} {...props} />;

export default BadgeComp;
